import { optionalAuthHeader } from "./user-service";
const url = "/api/v1/";
import axios from "axios";

// passes payment object info to backend and returns a secret key to be used for payment processing
export const saveTransaction = async (transactionObject) => {

    /* create url for saving user transaction */
    const saveUserTransaction = url + "marketplace/transactions/websiteTransaction";
  
    return new Promise(async (resolve, reject) => {
      try {
                
        const response = await fetch(saveUserTransaction, {
          method: "POST",
          body: JSON.stringify(transactionObject),
          headers: 
            {   
                ...(await optionalAuthHeader()),
                "Content-Type": "application/json",
                "accept": "application/json"
            },
        });
  
        let json = await response.json();

        console.log('saveUserTransaction response:', json);
  
        if (response.status >= 400 && response.status < 600) {
          throw('error getting payment intent...', response)        
        }
  
        resolve(json);
  
      } catch (e) {
        reject(new Error(e));
      }
    });
    
  };